import { NotificationSystem } from '@/components/quick-wins';
import React from 'react';

const Notificacoes: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <NotificationSystem />
    </div>
  );
};

export default Notificacoes;
